const sortDepth = new function sortDepth() {
  this.sort = function sort(depth) {
    depth.sort((a, b) => a[2] - b[2]);
    return depth;
  };

  this.median = function median(depth) {
    const i = Math.floor((depth.length / 3) * 2);
    return depth[i] && (depth[i][2] < 1 ? 1 : depth[i][2]);
  };

  this.medianUnit = function medianUnit(buydepth, sellDepth, colorWidth) {
    let tmpBuy = [...buydepth];
    // tmpBuy = tmpBuy[0];
    let tmpSell = [...sellDepth];
    // tmpSell = tmpSell[0];
    tmpBuy = tmpBuy.concat(tmpSell);
    const result = this.median(this.sort(tmpBuy)) / colorWidth;
    tmpBuy = null;
    tmpSell = null;
    return result;
  };

  this.width = function width(amount, medianUnit) {
    if (medianUnit === 0) {
      return 1;
    }
    const result = Math.round(Number(amount) / medianUnit);
    if (result <= 0) {
      return 1;
    } if (result > 160) {
      return 160;
    }
    return result;
  };
}();

const depthDivWidth = 253;

export default function computBarWidth(buy, sell) {
  buy = buy || [];
  sell = sell || [];

  const buycopy = [];
  const sellcopy = [];
  buy.forEach((key) => {
    buycopy.push(key);
  });
  sell.forEach((key) => {
    sellcopy.push(key);
  });
  const medianUnit = sortDepth.medianUnit(buycopy, sellcopy, 48);


  buy.forEach((key) => {
    key[3] = (sortDepth.width(key[2], medianUnit) * depthDivWidth) / 100;
  });
  sell.forEach((key) => {
    key[3] = (sortDepth.width(key[2], medianUnit) * depthDivWidth) / 100;
  });

  return { bids: buy, asks: sell };
}
